var map = {
	"./Syllabus.png": "16cb",
	"./admin.svg": "2539",
	"./alerts.svg": "8e62",
	"./ask.svg": "ab2e",
	"./attendance.svg": "84d7",
	"./bus-school.png": "8485",
	"./bus.svg": "6769",
	"./bus_location_pin.svg": "a1e0",
	"./downloads.svg": "d868",
	"./events.svg": "c9f8",
	"./exams.svg": "c202",
	"./fee.svg": "fa62",
	"./feedback.svg": "e045",
	"./fees.svg": "01c6",
	"./gallery.svg": "9da7",
	"./holidays.svg": "b449",
	"./homework.svg": "8755",
	"./live.svg": "44d5",
	"./magazine.svg": "d56f",
	"./notice.svg": "b6dd",
	"./quiz.png": "f7c9",
	"./student_documents.png": "21be2",
	"./tests.svg": "dc1f",
	"./timetable.svg": "2a78",
	"./video_conference.svg": "941f",
	"./website.svg": "f71d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2de2";